import { InventoryCreationDTO } from "./inventory-creation.dto";
import { ActionInventory } from "./type/action-inventory.enum";

export class ActionInventoryCreationDTO extends InventoryCreationDTO {
  action!: ActionInventory.creation;
}
